export default __webpack_public_path__ + "static/Inter-Bold-eccbcfa9bc0203198ac64a4db0cded7e.woff2";